// Path: ./src/hooks/useAnalyticsScope.ts
import { useContext } from "react";
import { GoFlyerAdminContext } from "../contextApi/context";
import { verifyRole } from "../utils/IsAuthenticated";
import { SUPERADMIN } from "../utils/constant/stringConstant";

/**
 * Resolves what the signed-in admin can see on the Analytics page.
 * Page access itself is gated by the "analytics-view" role permission;
 * the backend auto-scopes analytics data to the user's merchants/stores.
 */
export const useAnalyticsScope = () => {
  const { state } = useContext(GoFlyerAdminContext);

  const isSuperAdmin = state.user?.parsedRoles?.name === SUPERADMIN;

  const hasAssignedMerchantsOrStores =
    !!state.user?.merchant?.length ||
    !!state.user?.stores?.length ||
    !!state.gfAdminUser?.merchant?.length ||
    !!state.gfAdminUser?.stores?.length;

  // "analytics-filter" permission controls whether the filter bar is shown
  const canUseFilters = verifyRole("analytics", "filter");

  // users locked to their own merchants/stores can't pick other ones
  const hideMerchantAndStoreFilters =
    !isSuperAdmin && hasAssignedMerchantsOrStores;

  return {
    isSuperAdmin,
    canUseFilters,
    hideMerchantAndStoreFilters,
  };
};
